import { createSelector } from "@reduxjs/toolkit";

export const selectSlice = (state) => state.mcSquare;

export const simpleSelectorFor = (field) =>
  createSelector(selectSlice, (state) => state[field]);
